'use client';

import type { ReactNode } from 'react';

/**
 * Pass-through. Anonymous web visitors are NOT redirected to /login;
 * they should see (auth) pages render best-effort, with personalised
 * sections handling their own empty/anon state. Login is offered
 * via a "Войти" CTA in the page chrome (DesktopHeader / similar) —
 * the user opts in rather than being forced.
 *
 * Kept as a component so the (auth)/layout.tsx tree shape stays
 * stable and the gate can grow later (e.g. show login overlay over
 * the Steam-Trade form, gate `pushScreen` to bid placement endpoints).
 */
export function AuthGate({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
